export const stackWrapperStyle = {
  p: 0,
  m: 0,
  listStyle: 'none',
  overflowY: 'auto',
  paddingTop: '12px',
  height: '430px',
  width: { xs: '60%', sm: '90%' },
}

export const typographyStyle = {
  fontWeight: 700,
}

export const checkBoxStyle = {}

export const boxTitleWrapper = {
  width: 13,
  height: 13,
  flexShrink: 0,
  marginRight: 1,
}
